import { createContext, useContext } from 'react';
export const WebVoiceContext = createContext(null);
export function useWebVoiceContext() {
    return useContext(WebVoiceContext);
}
//# sourceMappingURL=WebVoiceContext.js.map